<template>
  <div class="search-page mx-auto max-w-screen-4xl lg:px-4">
    <MissingTranslationNotification
      class="mt-8 px-4 lg:pl-0"
    />
    <PageTitle
      v-if="!showCampaignInfo"
      :page-title="$t('search-page-title')"
    />
    <CtSearchContainer
      v-if="isCtProductSearchEnabled"
      show-search-box
    />
    <TypesenseContainer
      v-else
      category-filter=""
      :language-and-country="languageAndCountry"
      :enable-state-mapping="true"
      description=""
      :product-group-items="[]"
      product-group-items-text-color="text-EXPONDO-black"
      product-group-items-background-color="bg-EXPONDO-grey-5"
    />
    <div v-if="isTrustedBrandsExists"><RenderContent :content="trustedBrandsContent" /></div>
  </div>
</template>

<script lang="ts">
import { COMPONENTS } from '~~/constants/cms';
import { ROUTES, ROUTES_INFORMATION } from '~~/constants/routes';
import { generateMetaTitleWithCTFormat } from '~~/helpers/commercetools/meta/generateMetaTitle';

// Same layout as category and product pages: switching layouts remounts the header and adds a second fade.
definePageMeta({
  layout: 'default-full-width',
  middleware: ['check-search-params', 'typesense-sort-by-redirection'],
});

export default defineComponent({
  name: 'SearchPage',
  setup() {

    const i18n = useI18n();
    const {
      loadComponent: trustedBrandsSearch,
      internalCmsContent: trustedBrandsContent,
      canShowContent: isTrustedBrandsExists,
    } = useInternalCms(COMPONENTS.TRUSTED_BRANDS.SLUG);

    const { callPageViewEvent } = usePageViewEvent();

    useLazyAsyncData(`trusted-brands-${COMPONENTS.TRUSTED_BRANDS.SLUG}`, async () => {

      await trustedBrandsSearch();

      return '';

    });

    useMetaExtended({
      metaTitle: computed(() => generateMetaTitleWithCTFormat({
        title: i18n.t('search-page-title'), i18n,
      })),
      isPageIndexed: ref(false),
      slug: ref(ROUTES_INFORMATION[ROUTES.SEARCH].SLUG),
      isPageHreflangLinkHidden: ref(true),
    });

    const {
      showCampaignInfo,
    } = useDisplayCampaignInfo();

    onMounted(() => {

      callPageViewEvent();

    });

    const { languageAndCountry } = useLocalization();
    const { isCtProductSearchEnabled } = useIsCtProductSearchEnabled();

    return {
      trustedBrandsContent,
      isTrustedBrandsExists,
      languageAndCountry,
      isCtProductSearchEnabled,
      showCampaignInfo,
    };

  },
});
</script>
